import { Button } from "@/components/ui/Button";
import { Settings, ChevronRight } from "lucide-react";
import { useState } from "react";

interface MatchSettingsMenuProps {
  onNavigate?: (path: string) => void;
}

export function MatchSettingsMenu({ onNavigate }: MatchSettingsMenuProps) {
  const [isNavigating, setIsNavigating] = useState(false);

  const handleClick = () => {
    setIsNavigating(true);
    setTimeout(() => {
      onNavigate?.("/match-settings");
      setIsNavigating(false);
    }, 200);
  };

  return (
    <Button
      variant="ghost"
      className="gap-3 w-full justify-between hover:bg-accent hover:text-blue-600 group px-2 text-[#0F0F0F] transition-all duration-200"
      onClick={handleClick}
      disabled={isNavigating}
    >
      <div className="flex items-center gap-3">
        <div className="h-5.5 w-5.5 flex items-center justify-center">
          <Settings className="group-hover:text-blue-600" />
        </div>
        <span className="text-[#0F0F0F] text-base">匹配设置</span>
      </div>
      <ChevronRight 
        className={`w-4 h-4 text-muted-foreground transition-transform duration-200 ${
          isNavigating ? 'translate-x-1' : 'group-hover:translate-x-1'
        }`} 
      />
    </Button>
  );
}

export default MatchSettingsMenu;
